import { render } from "./PreciseModal.vue?vue&type=template&id=2cd495f7"
import script from "./PreciseModal.vue?vue&type=script&lang=js"
export * from "./PreciseModal.vue?vue&type=script&lang=js"

import exportComponent from "F:\\jenkins\\data\\workspace\\ZYZB\\zyzb-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__